import { EcranHistorique } from '@/components/historique/ecran-historique';
import { exigerSession } from '@/lib/garde-session';
import { noyauxDeLAdresse, rechercheHistoriqueSchema } from '@/lib/params-recherche';
import type { NoyauCode } from '@rosetta/shared';
import { createFileRoute } from '@tanstack/react-router';

/**
 * `/historique`: the translations of the user, behind the same session guard as the other pages.
 * The search and the noyau filter are in the address (B8, #13): "retour" from a card finds them
 * again, and each change replaces the entry instead of piling one up per keystroke.
 */
export const Route = createFileRoute('/historique')({
  validateSearch: (recherche) => rechercheHistoriqueSchema.parse(recherche),
  beforeLoad: ({ location }) => {
    exigerSession(location.href);
  },
  component: HistoriquePage,
});

function HistoriquePage() {
  const { recherche = '', noyaux } = Route.useSearch();
  const navigate = Route.useNavigate();

  function changer(suivante: { recherche: string; noyaux: readonly NoyauCode[] }) {
    void navigate({
      search: {
        ...(suivante.recherche === '' ? {} : { recherche: suivante.recherche }),
        ...(suivante.noyaux.length === 0 ? {} : { noyaux: suivante.noyaux.join(',') }),
      },
      replace: true,
    });
  }

  const choisis = noyauxDeLAdresse(noyaux);
  return (
    <EcranHistorique
      recherche={recherche}
      noyaux={choisis}
      onRecherche={(suivante) => changer({ recherche: suivante, noyaux: choisis })}
      onNoyaux={(suivants) => changer({ recherche, noyaux: suivants })}
    />
  );
}
